import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SBInvoiceDetailsPageActions from '../components/SBInvoiceDetailsPageActions';
import SBInvoiceForm from '../components/SBInvoiceForm';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import PeppolResponseStatusCard from '../../common/PeppolResponseStatusCard';
import { useGetInvoiceHandler } from '../../Invoices/dataHandlers/getInvoiceHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function SBInvoiceDetailsPage() {
  useDocumentTitle('Self Billed Invoice Details');
  const { document_id } = useParams();
  const { invoice, isLoading } = useGetInvoiceHandler(document_id);
  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {invoice && (
        <Box sx={{ pb: 4 }}>
          <TopBar title="Self Billed Invoice Details" identifier={invoice?.document_id}>
            <SBInvoiceDetailsPageActions data={invoice} />
          </TopBar>
        </Box>
      )}
      <IrbmStatusCard document={invoice} />
      <PeppolResponseStatusCard document={invoice} />
      <SBInvoiceForm onSubmit={() => {}} onCancel={() => {}} initialData={invoice} readOnly={true} />
    </Stack>
  );
}
